import {DataGridPro} from '@mui/x-data-grid-pro'
import dayjs from 'dayjs'
import {customerFreezeWarningColumns} from 'pages/customer/dataConfig/declearColumns'
import {customerFreezeWarningFilter} from 'pages/customer/dataConfig/declearFilters'
import {customerFreezeWarningRows} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {getFreezeWarningList} from 'utils/apiCalling/api'

import CustomPagination from 'utils/designSytem/CustomPagination'
import MeterariumPageLayout from 'utils/designSytem/MeterariumPageLayout'
import {scrollTop} from 'utils/func/justUtils'
import {reduxType} from 'utils/interface/reduxType'
import {toolTipText} from 'utils/toolTips/toolTipText'
import {customerInfoGroup} from '../dataConfig/declearGroupingModel'

const CustomerFreezeWarning = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const location = useLocation()
  const pageState = location?.state
  const officeInfo = useSelector((state: reduxType) => state.officeInfo)
  const cooperInfo = useSelector((state: reduxType) => state.cooperInfo)
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [freezeWarningList, setFreezeWarningList] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [filter, setFilter] = useState<any>(customerFreezeWarningFilter(pageState))
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false)
  const [shouldCallApi, setShouldCallApi] = useState<boolean>(false)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const getFreezeWarningCustomerList = () => {
    const checkBusan = String(officeInfo.value).slice(0, 2) === '13'
    const hasAnyTrue = Object.values(filter.searchOption).some((v) => v === true)
    const newSearchOption =
      !filter.searchOption.customerNumber && hasAnyTrue
        ? {installer: false}
        : {customerNumber: true}
    let selectedFilter = filter
    if (checkBusan) {
      selectedFilter = {
        ...filter,
        searchOption: newSearchOption,
        // searchOption: {
        //   customerNumber:
        //     !filter.searchOption.customerNumber && !filter.searchOption.managerName
        //       ? true
        //       : filter.searchOption.customerNumber,
        //   managerName:
        //     !filter.searchOption.customerNumber && !filter.searchOption.managerName
        //       ? true
        //       : filter.searchOption.managerName,
        // },
      }
    }

    getFreezeWarningList(officeInfo, cooperInfo, selectedFilter, {
      success: (res: any) => {
        setFreezeWarningList(res)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {
        setLoading(loading)
      },
      count: (count: number) => {
        setTotalCount(count)
      },
    })
  }

  const columns: any = customerFreezeWarningColumns(filter)
  const columnGroupingModel = customerInfoGroup
  const rows = customerFreezeWarningRows(freezeWarningList)

  const busanSearchHandler = (officeId: any) => {
    // const checkBusan = String(officeId).slice(0, 2) === '13'
    // if (checkBusan) {
    //   return ['customerNumber', 'managerName']
    // } else {
    return ['customerNumber', 'customerName', 'address', 'managerName']
    // }
  }
  const searchHandler = () => {
    setFilter((prev: any) => ({...prev, page: 1}))
    setShouldCallApi(true)
  }
  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  useEffect(() => {
    if (shouldCallApi) {
      getFreezeWarningCustomerList()
      setShouldCallApi(false)
    }
  }, [filter, shouldCallApi])

  useEffect(() => {
    // location.state가 존재하면 freezeWarningType에 따라 선택 값을 설정
    if (location.state && location.state.freezeWarningType) {
      setFilter({...filter, freezeWarningType: location.state.freezeWarningType})
    }
  }, [])
  useEffect(() => {
    scrollTop()
    getFreezeWarningCustomerList()
  }, [officeInfo, cooperInfo, filter.freezeWarningType, filter.rowPerPage, filter.page])
  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  return (
    <>
      <MeterariumPageLayout
        headerDescription={toolTipText.customerFreezeWarning.description}
        tooltipText={toolTipText.customerFreezeWarning.text}
        hideSearchOptions={accordionOpen}
        setHideSearchOptions={setAccordionOpen}
        filter={filter}
        id={'customer-freeze-warning'}
        setFilter={setFilter}
        searchCallback={searchHandler}
        total={totalCount}
        // hideSearchOptions={true}
        control={['freezeWarning']}
        actions={['freezeWarning']}
        date={[{date: dayjs().format('YYYYMMDD')}]}
        asValue={''}
        searchOptions={busanSearchHandler(officeInfo.value)}
        checkData={null}
        onDelete={null}
        onCancel={null}
        setTypeName={null}
      >
        <DataGridPro
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{columnGrouping: true}}
          rows={rows}
          rowCount={rows?.length}
          columns={columns}
          rowHeight={260}
          disableColumnMenu
          paginationMode={'server'}
          loading={loading}
          pagination={true}
          hideFooter={true}
          autoHeight={true}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
          }}
        />
        <CustomPagination filter={filter} setFilter={setFilter} totalCount={totalCount} />
      </MeterariumPageLayout>
    </>
  )
}

export default CustomerFreezeWarning
